import { useAuth } from "@/context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import PendingReview from "@/pages/PendingReview";
import Subscribe from "@/pages/Subscribe";

const GATE_STATES = ["REJECTED", "SUSPENDED", "WAITLISTED"];

export default function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg">
        <div className="font-mono text-muted text-sm animate-pulse">Chargement…</div>
      </div>
    );
  }
  if (!user) {
    // Préserve la destination (deep-link email) pour y revenir après connexion.
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (user.role === "admin") return children;

  const ent = user.entitlements || {};
  const isFinalClient = (ent.org_type || user.organization?.org_type) === "FINAL_CLIENT";
  const status = user.organization?.approval_status;

  // Client final : accès Marketplace après validation admin.
  if (isFinalClient) {
    if (!ent.approved) return <PendingReview />;
    return children;
  }

  // ESN : l'accès est débloqué par l'abonnement (plus de trial, plus de validation manuelle).
  if (ent.is_paid) return children;
  if (GATE_STATES.includes(status)) return <PendingReview />;
  return <Subscribe />;
}
